var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { singleton } from '../decorators';
import { generateUuid } from '../utils';
import { MasterDataSDK } from './MasterData.sdk';
import { CustomerMembershipService } from './services/CustomerMembership.service';
import { OrderService } from './services/Order.service';
let NekoPosSdk = class NekoPosSdk extends MasterDataSDK {
    api;
    id;
    customerMembership;
    order;
    constructor(api, id = generateUuid()) {
        super(api, id);
        this.api = api;
        this.id = id;
        this.customerMembership = new CustomerMembershipService(this.api, this.getAuthHeader);
        this.order = new OrderService(this.api, this.getAuthHeader);
    }
};
NekoPosSdk = __decorate([
    singleton,
    __metadata("design:paramtypes", [String, Object])
], NekoPosSdk);
export { NekoPosSdk };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTmVrb1Bvcy5zZGsuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2Rrcy9OZWtvUG9zLnNkay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sZUFBZSxDQUFDO0FBQzFDLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSxVQUFVLENBQUM7QUFDeEMsT0FBTyxFQUFFLGFBQWEsRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBQ2pELE9BQU8sRUFBRSx5QkFBeUIsRUFBRSxNQUFNLHVDQUF1QyxDQUFDO0FBQ2xGLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSwwQkFBMEIsQ0FBQztBQUdqRCxJQUFNLFVBQVUsR0FBaEIsTUFBTSxVQUFXLFNBQVEsYUFBYTtJQUlyQjtJQUF1QjtJQUg3QyxrQkFBa0IsQ0FBNEI7SUFDOUMsS0FBSyxDQUFlO0lBRXBCLFlBQXNCLEdBQVcsRUFBWSxLQUFLLFlBQVksRUFBRTtRQUM5RCxLQUFLLENBQUMsR0FBRyxFQUFFLEVBQUUsQ0FBQyxDQUFDO1FBREssUUFBRyxHQUFILEdBQUcsQ0FBUTtRQUFZLE9BQUUsR0FBRixFQUFFLENBQWlCO1FBRTlELElBQUksQ0FBQyxrQkFBa0IsR0FBRyxJQUFJLHlCQUF5QixDQUNyRCxJQUFJLENBQUMsR0FBRyxFQUNSLElBQUksQ0FBQyxhQUFhLENBQ25CLENBQUM7UUFDRixJQUFJLENBQUMsS0FBSyxHQUFHLElBQUksWUFBWSxDQUFDLElBQUksQ0FBQyxHQUFHLEVBQUUsSUFBSSxDQUFDLGFBQWEsQ0FBQyxDQUFDO0lBQzlELENBQUM7Q0FDRixDQUFBO0FBWlksVUFBVTtJQUR0QixTQUFTOztHQUNHLFVBQVUsQ0FZdEIifQ==